import React from 'react'
import Header from 'components/Header'
import { Box } from '@mui/material'
import AppRoutes from 'routers/AppRoutes'
import Footer from 'components/Footer'
import { useMaintenance } from 'hooks/useMaintenance'
import MaintenancePage from 'pages/Maintenance'

const Layout = () => {
  const { isMaintenance, maintenanceTitle, maintenanceDescription } =
    useMaintenance()

  if (isMaintenance) {
    return (
      <MaintenancePage
        title={maintenanceTitle}
        description={maintenanceDescription}
      />
    )
  }

  return (
    <>
      <Header />
      <Box component='main' sx={{ minHeight: '80vh', marginBottom: 0 }}>
        <AppRoutes />
      </Box>
      <Footer />
    </>
  )
}

export default Layout
